import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialIntroductoryState: IIntroductoryState = {
  data: {
    introductory: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface IIntroductoryState {
  data?: {
    introductory?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IIntroductoryState = initialIntroductoryState,
  action: ActionWithPayload<IIntroductoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_INTRODUCTORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_INTRODUCTORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_INTRODUCTORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_INTRODUCTORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_INTRODUCTORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_INTRODUCTORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_INTRODUCTORY_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_INTRODUCTORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_INTRODUCTORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_INTRODUCTORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_INTRODUCTORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_INTRODUCTORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_INTRODUCTORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_INTRODUCTORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_INTRODUCTORY_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_INTRODUCTORY_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_INTRODUCTORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_INTRODUCTORY_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_INTRODUCTORY_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_INTRODUCTORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_INTRODUCTORY_SUCCESS: {
      return {
        ...state,
        sortIntroductoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_INTRODUCTORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_INTRODUCTORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortIntroductoryData: [],
      }
    }

    default:
      return state
  }
}
